import React from 'react';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import AppVars from '../../../../AppVars';
import Logger from '../../../../Logger';

let appVars = AppVars.getInstance()
let logger = Logger.getInstance()

class RegisterCompleteView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Registration</div>
                    </Row>
                    <Row className = "title__TO left">Check Your Email</Row>
                    <Row className = "justify-content-center text__TO">
                        We sent an email to <b>{this.props.email}</b> with a link to verify your account and complete your registration. This link will be active for 72 hours.
                    </Row>
                    <Row className = "justify-content-center text__TO">
                        Tip: If you don't see the email, make sure to check your spam folder.
                    </Row>
                    <Row className = "justify-content-center text__TO">
                        Didn't receive the email?<br className = "mobile-br"/> <a style = {{"marginTop" : "0px", "margin-left" : "10px"}} className = "create-account" href = {appVars.getResendActivationEmailURL(this.props.style)}>Resend Email</a>
                    </Row>
                    <div>
                    </div>
                    <div style = {{'display' : 'grid', 'grid-template-rows' : '60px', 'grid-template-columns' : '176px', 'margin-left' : '-4px', 'marginBottom' : '16px'}}>
                    <a href= "/"><Button style = {{"marginTop" : "15px"}} data-testid = "SignInButton" bsPrefix = "float-left button__TO" type = "button" >Sign In</Button></a>
                    </div>
                </div>
            </div>
        </div>
        )
  }
}

export default RegisterCompleteView;